import { useCallback } from 'react'
import { type VideoId, type VideoWithUserData, type VideoGetInput, type VideoGetSuccess, HOUR } from '@terros/common'
import { useQueryClient } from '@tanstack/react-query'
import { videoKey } from '../keys'
import { useServerRequest } from '../api'

export function useFetchVideo(): (videoId: VideoId) => Promise<VideoWithUserData> {
  const serverRequest = useServerRequest<VideoGetInput, VideoGetSuccess>('/video/get')
  const queryClient = useQueryClient()
  return useCallback(
    async (videoId: VideoId): Promise<VideoWithUserData> => {
      return queryClient.fetchQuery({
        queryKey: videoKey(videoId),
        staleTime: HOUR,
        queryFn: async () => {
          const res = await serverRequest({ videoId })
          return { video: res.video, videoUser: res.videoUser }
        },
      })
    },
    [queryClient, serverRequest]
  )
}
